import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';

import { routes } from './app.routes';
import { ToastrModule } from 'ngx-toastr';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { AuthInterceptor } from './auth.interceptor';
import { PreloadService } from './services/preload.service';
import { NzModalModule } from 'ng-zorro-antd/modal';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideAppInitializer(() => {
		const preloadService = inject(PreloadService);
			return preloadService.preloadImage('assets/images/biorugged.png');
		}),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimations(),
    	provideNzI18n(en_US),

		// Provide JWT helper
		{ provide: JWT_OPTIONS, useValue: {} },
		JwtHelperService,

		// Register interceptor
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		importProvidersFrom(
			BrowserAnimationsModule,
			NzModalModule,
			ToastrModule.forRoot({
				positionClass: 'toast-top-right',
				timeOut: 3000,
				progressBar: true,
				closeButton: true,
			})
			// ToastrModule.forRoot({
			// 	positionClass: 'toast-top-right',
			// 	timeOut: 3000,
			// 	progressBar: true,
			// 	closeButton: true,
			// })
		)
	]
};
